import type { WebGLRenderer } from "three";

/**
 * Handle to the active sandbox WebGLRenderer for imperative thumbnail capture.
 *
 * Why a module singleton (not React context / useThree):
 * - Auto-thumbnail runs from plain helpers after generate/save, outside the R3F tree.
 * - Those helpers cannot call useThree(); they need a sync getGl() after the canvas mounts.
 *
 * Lifecycle (owned by SandboxCanvas):
 * - setGl(gl) in Canvas onCreated
 * - setGl(null) on unmount so we don't retain a disposed renderer
 *
 * Assumes a single sandbox Canvas. A second concurrent R3F Canvas would overwrite
 * this handle — capture from the owning component instead if that ever lands.
 */
let gl: WebGLRenderer | null = null;

/** Register or clear the active sandbox renderer. Pass null on canvas unmount. */
export function setGl(renderer: WebGLRenderer | null): void {
  gl = renderer;
}

/** Current sandbox renderer, or null if the canvas is not mounted. */
export function getGl(): WebGLRenderer | null {
  return gl;
}
